/* eslint-disable react-hooks/exhaustive-deps */
import { FileDown, XCircle } from 'lucide-react'
import { useEffect, useState } from 'react'
import { Button, Col, Modal, Row } from 'react-bootstrap'
import api from '../../../config/AxiosInstance'
import { convertDateWithTime } from '../../../helpers/constants'
import * as Common from '../../../utils/Common'
import { firstLetterUpperCase } from '../../../utils/TextFormatter'
import './style.css'

const verticalLineStyle = {
  borderLeft: '2px solid #E0E0E0',
  width: '0px'
}

const circleStyle = {
  width: '15px',
  height: '15px',
  background: '#E0E0E0',
  borderRadius: '50%',
  marginTop: '5px'
}

const titleHistoryStyle = {
  color: '#828282',
  fontSize: '14px',
  fontWeight: '600',
  marginBottom: '0.2rem'
}

const PrDetailTimeline = (props) => {
  const { timelineId, show, type = undefined, irId = undefined } = props
  const [detail, setDetail] = useState({})
  const [loadingFile, setLoadingFile] = useState({
    armada: false,
    material: false,
    goodReceipt: false
  })
  const [loading, setLoading] = useState(false)
  const fetchTimeline = async () => {
    try {
      setLoading(true)
      let url = `inbound/pr-draft/history/${timelineId}`
      if (type === 'ir') {
        url = `/inbound/return/${irId}/${timelineId}`
      } else if (type === 'mr') {
        url = `/inbound/material-reject/${irId}/${timelineId}`
      }
      const { data } = await api.get(url)
      if (data.success) {
        setDetail(data.data)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (timelineId) {
      fetchTimeline()
    }
  }, [timelineId, show])

  const handleRemove = async () => {
    try {
      const data = {
        action: detail?.inbound?.status
      }
      const res = await api.post(
        `inbound/pr-draft/unassign/${detail?.inbound.id}`,
        data
      )

      if (res.data.success) {
        props.refreshData()
        Common.showPopUpSuccessMessage(res.data.message)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  const handleDownloadArmada = async () => {
    try {
      setLoadingFile((prev) => ({ ...prev, armada: true }))
      const res = await api.get(
        `/inbound/pr-draft/${detail?.inbound?.id}/download-armada`,
        {
          responseType: 'arraybuffer'
        }
      )
      const { status, data } = res
      if (status === 200) {
        const blob = new Blob([data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        // Create a link element, set the href to the URL, and trigger a download
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `download-armada-${detail?.inbound?.id}.pdf`
        ) // Set the file name
        document.body.appendChild(link)
        link.click() // Trigger the download
        // Clean up
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(err)
    } finally {
      setLoadingFile((prev) => ({ ...prev, armada: false }))
    }
  }

  const handleDownloadMaterial = async () => {
    try {
      setLoadingFile((prev) => ({ ...prev, material: true }))
      let url = `/inbound/pr-draft/${detail?.inbound?.id}/download-material`
      if (type === 'ir') {
        url = `/inbound/return/${irId}/${detail?.inbound?.id}/material`
      } else if (type === 'mr') {
        url = `/inbound/material-reject/${irId}/${detail?.inbound?.id}/material`
      }
      const res = await api.get(url, {
        responseType: 'arraybuffer'
      })
      const { status, data } = res
      if (status === 200) {
        const blob = new Blob([data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        // Create a link element, set the href to the URL, and trigger a download
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `download-material-${detail?.inbound?.id}.pdf`
        ) // Set the file name
        document.body.appendChild(link)
        link.click() // Trigger the download
        // Clean up
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(err)
    } finally {
      setLoadingFile((prev) => ({ ...prev, material: false }))
    }
  }
  const handleDownloadGoodReceipt = async () => {
    try {
      setLoadingFile((prev) => ({ ...prev, goodReceipt: true }))
      let url = `/inbound/pr-draft/${detail?.inbound?.id}/download-good-receipt`
      if (type === 'ir') {
        url = `/inbound/return/${irId}/${detail?.inbound?.id}/receipt`
      } else if (type === 'mr') {
        url = `/inbound/material-reject/${irId}/${detail?.inbound?.id}/receipt`
      }
      const res = await api.get(url, {
        responseType: 'arraybuffer'
      })
      const { status, data } = res
      if (status === 200) {
        const blob = new Blob([data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        // Create a link element, set the href to the URL, and trigger a download
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `download-goodsreceipt-${detail?.inbound?.id}.pdf`
        ) // Set the file name
        document.body.appendChild(link)
        link.click() // Trigger the download
        // Clean up
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    } catch (error) {
      const err = error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(err)
    } finally {
      setLoadingFile((prev) => ({ ...prev, goodReceipt: false }))
    }
  }

  return (
    <Modal {...props} centered size="lg">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title>
          <h5 className="fw-bold text-uppercase">{detail?.inbound?.ticket}</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-0 p-0">
        {!loading && (
          <div className="ps-3 pe-3 pb-3">
            <Row className="mt-4 align-items-center">
              <Col md={4}>
                <h5 className="fw-bold mb-0">{detail?.inbound?.vehicle}</h5>
              </Col>
              <Col md={8}>
                <div className="d-flex align-items-center h-100">
                  <span
                    className="me-2 text-muted"
                    style={{ fontSize: '14px', fontWeight: '500' }}
                  >
                    Current Status:
                  </span>
                  {detail?.inbound?.status === 'put_away' ? (
                    <span style={{ fontSize: '14px', fontWeight: '600' }}>
                      Put Away by{' '}
                      {detail?.inbound?.action?.pnp?.name === null ? (
                        <span style={{ color: 'var(--primary-orange)' }}>
                          ---
                        </span>
                      ) : (
                        <div className="d-inline-block dropdown">
                          <span
                            style={{
                              color: 'var(--primary-orange)',
                              cursor: 'pointer'
                            }}
                          >
                            {detail?.inbound?.action?.pnp?.name}{' '}
                          </span>
                          <div className="dropdown-content">
                            <small
                              style={{ cursor: 'pointer' }}
                              className="text-danger fw-bold d-flex align-items-center"
                              onClick={() => handleRemove()}
                            >
                              <XCircle size={14} className="text-danger me-2" />
                              REMOVE
                            </small>
                          </div>
                        </div>
                      )}
                    </span>
                  ) : detail?.inbound?.status === 'waiting_om' ||
                    detail?.inbound?.status === 'waiting_pnp' ? (
                    <span style={{ fontSize: '14px', fontWeight: '600' }}>
                      {detail?.inbound?.status === 'waiting_om'
                        ? 'Waiting OM'
                        : 'Waiting PNP'}
                    </span>
                  ) : detail?.inbound?.status === 'receiving_progress' ? (
                    <span style={{ fontSize: '14px', fontWeight: '600' }}>
                      Receiving By{' '}
                      {detail?.inbound?.action?.rnr?.name === null ? (
                        <span style={{ color: 'var(--primary-orange)' }}>
                          ---
                        </span>
                      ) : (
                        <div className="d-inline-block dropdown">
                          <span
                            style={{
                              color: 'var(--primary-orange)',
                              cursor: 'pointer'
                            }}
                          >
                            {detail?.inbound?.action?.rnr?.name}{' '}
                          </span>
                          <div className="dropdown-content">
                            <small
                              style={{ cursor: 'pointer' }}
                              className="text-danger fw-bold d-flex align-items-center"
                              onClick={() => handleRemove()}
                            >
                              <XCircle size={14} className="text-danger me-2" />
                              REMOVE
                            </small>
                          </div>
                        </div>
                      )}
                    </span>
                  ) : (
                    <span style={{ fontSize: '14px', fontWeight: '600' }}>
                      {detail?.inbound?.status === 'waiting_rnr'
                        ? 'Waiting RnR'
                        : firstLetterUpperCase(detail?.inbound?.status)}
                    </span>
                  )}
                </div>
              </Col>
            </Row>
            <Row className="mt-4 mb-4">
              <Col md={12}>
                <div className="d-flex flex-row gap-3">
                  {[
                    'receiving_progress',
                    'waiting_om',
                    'put_away',
                    'waiting_pnp',
                    'done'
                  ].includes(detail?.inbound?.status) &&
                    type !== 'mr' &&
                    !type && (
                      <Button
                        variant="light"
                        className="d-flex align-items-center border shadow-sm bg-white"
                        onClick={() => handleDownloadArmada()}
                        disabled={loadingFile.armada}
                        style={{ borderRadius: '8px' }}
                      >
                        <FileDown size={18} className="text-warning me-2" />
                        <span style={{ fontSize: '13px', fontWeight: '600' }}>
                          {!loadingFile.armada
                            ? 'Checklist Armada'
                            : 'Download...'}
                        </span>
                      </Button>
                    )}
                  {['waiting_om', 'put_away', 'waiting_pnp', 'done'].includes(
                    detail?.inbound?.status
                  ) && (
                    <Button
                      variant="light"
                      className="d-flex align-items-center border shadow-sm bg-white"
                      onClick={() => handleDownloadMaterial()}
                      disabled={loadingFile.material}
                      style={{ borderRadius: '8px' }}
                    >
                      <FileDown size={18} className="text-warning me-2" />
                      <span style={{ fontSize: '13px', fontWeight: '600' }}>
                        {!loadingFile.material
                          ? 'Checklist Materials'
                          : 'Download...'}
                      </span>
                    </Button>
                  )}
                  {[
                    'receiving_progress',
                    'waiting_om',
                    'waiting_pnp',
                    'put_away',
                    'done'
                  ].includes(detail?.inbound?.status) && (
                    <Button
                      variant="light"
                      className="d-flex align-items-center border shadow-sm bg-white"
                      onClick={() => handleDownloadGoodReceipt()}
                      disabled={loadingFile.goodReceipt}
                      style={{ borderRadius: '8px' }}
                    >
                      <FileDown size={18} className="text-warning me-2" />
                      <span style={{ fontSize: '13px', fontWeight: '600' }}>
                        {!loadingFile.goodReceipt
                          ? 'Goods Receipt'
                          : 'Download...'}
                      </span>
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
            <div className="mt-4 px-3 ps-2">
              {detail?.histories?.map((history, index) => (
                <div key={history.id} className="d-flex">
                  <div
                    className="d-flex flex-column align-items-center me-3"
                    style={{ width: '40px', minWidth: '40px' }}
                  >
                    <div style={circleStyle} />
                    {index !== detail.histories.length - 1 && (
                      <div
                        style={{
                          ...verticalLineStyle,
                          flex: 1,
                          minHeight: '30px',
                          marginBottom: '-5px'
                        }}
                      />
                    )}
                  </div>
                  <div className="pb-4">
                    <h6 style={titleHistoryStyle}>
                      {convertDateWithTime(history.createdAt)}
                    </h6>
                    <p className="text-muted mb-0" style={{ fontSize: '13px' }}>
                      {history.notes}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        {loading && (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: '200px' }}
          >
            <div className="spinner-border text-warning mb-0" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default PrDetailTimeline
